var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-modal",
      class: ((_obj = {}),
      (_obj["variant-" + _vm.variant] = !!_vm.variant),
      _obj),
      on: { click: _vm.clickStoper }
    },
    [
      _c(
        "div",
        { staticClass: "v-modal-header" },
        [
          _vm._t("header", [
            _vm.icon
              ? _c("div", { staticClass: "v-modal-icon" }, [
                  _c("i", {
                    staticClass: "far",
                    class: ((_obj$1 = {}),
                    (_obj$1["fa-" + _vm.icon] = !!_vm.icon),
                    _obj$1)
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title && !_vm.$slots.title
              ? _c("h5", { staticClass: "v-modal-title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$slots.title
              ? _c(
                  "div",
                  { staticClass: "v-modal-title" },
                  [_vm._t("title")],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "v-modal-close", on: { click: _vm.close } },
            [_c("i", { staticClass: "far fa-times" })]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "v-modal-body", class: { "no-padding": _vm.noPadding } },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.busy
            ? _c(
                "div",
                { staticClass: "v-modal-busy" },
                [_c("b-spinner", { attrs: { label: "Busy" } })],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "v-modal-footer" }, [_vm._t("footer")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }